import { useEffect, useState } from 'react';
import { GeoItem } from 'src/models/geoItem';
import { useHttpClient } from 'src/security/hooks/axiosProvider';

export const useProjectCommunes = (projectId: number | null | undefined) => {
  const [communes, setCommunes] = useState<GeoItem[]>([]);
  const [loading, setLoading] = useState(false);
  const httpClient = useHttpClient(true);

  useEffect(() => {
    if (!projectId) {
      setCommunes([]);
      return;
    }

    const fetchCommunes = async () => {
      setLoading(true);
      try {
        const response = await httpClient.current?.get(`/api/project/${projectId}/communes`);
        setCommunes(response?.data || []);
      } finally {
        setLoading(false);
      }
    };

    fetchCommunes();
  }, [httpClient, projectId]);

  return { communes, loading };
};
